export default __webpack_public_path__ + "static/media/noise.baf6667f.png";